import React from "react";
import {
  Link,
  animateScroll as scroll,
} from "react-scroll";

export default function LinkScroll(props) {
  const { children, className, to, offset, onClick } = props;

  return (
    <Link
      className={className}
      to={to}
      spy={true}
      smooth={true}
      offset={offset}
      duration={500}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}
